import { apiGet, apiSend, apiDelete } from './httpClient'
import type { TripLink } from './types'

export type UpdateLinkInput = {
  title?: string
  description?: string
  price?: number | null
  currency?: string
  check_in?: string | null
  check_out?: string | null
}

export async function listLinks(tripId: string): Promise<TripLink[]> {
  return apiGet<TripLink[]>(`/trips/${tripId}/links`)
}

export async function addLink(tripId: string, url: string): Promise<TripLink> {
  return apiSend<TripLink>('POST', `/trips/${tripId}/links`, { url })
}

export async function updateLink(tripId: string, linkId: string, patch: UpdateLinkInput): Promise<TripLink> {
  return apiSend<TripLink>('PATCH', `/trips/${tripId}/links/${linkId}`, patch)
}

export async function deleteLink(tripId: string, linkId: string): Promise<void> {
  return apiDelete(`/trips/${tripId}/links/${linkId}`)
}
